// extracted by mini-css-extract-plugin
module.exports = {"ContextMenuButtonPersistentActive":"context-menu-button_ContextMenuButtonPersistentActive__VxUXM","IsActive":"context-menu-button_IsActive__1uhsQ"};